import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import { ModuleRegistry, AllCommunityModule, provideGlobalGridOptions } from 'ag-grid-community';

// AG Grid v34: register features once for every grid, and keep all grids on the
// CSS-file theme (ag-theme-alpine) the screens are styled with. Without theme 'legacy',
// v33+ also injects its new theme and the two clash (broken table layouts).
ModuleRegistry.registerModules([AllCommunityModule]);
provideGlobalGridOptions({
  theme: 'legacy',
  paginationPageSizeSelector: [10, 20, 50, 100],
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
